import { IOfferSnippetSchema } from 'shared/repositories/commercial-search-offers/entities/offer_snippet/OfferSnippetSchema';

interface IGetSpecialProjectOffersPositionsParams {
  step: number;
  activeSlideIndex: number;
  offers: IOfferSnippetSchema[];
}

export function getSpecialProjectOffersPositions({
  step,
  activeSlideIndex,
  offers,
}: IGetSpecialProjectOffersPositionsParams) {
  return offers
    .map(offer => offer.id)
    .slice(activeSlideIndex, activeSlideIndex + step)
    .map((item, index) => ({ id: item, position: index + activeSlideIndex + 1 }));
}
